export const DEAL_FREEZE_OFFER_BOX_EXPERIMENT =
  '4977e4d6-deal-freeze-offer-box-web'

export const DEAL_FREEZE_OFFER_BOX_BANNER = 'DealFreezeOfferBoxBanner'
export const DEAL_FREEZE_OFFER_BOX_CARD = 'DealFreezeOfferBoxCard'
export const DEAL_FREEZE_OFFER_BOX_CARD_SKELETON =
  'DealFreezeOfferBoxCardSkeleton'
export const FREEZABLE_DEAL_TAG = 'FreezableDealTag'
